import { CheckCircle2, HelpCircle, AlertCircle } from "lucide-react-native";
import StatusBadge from "../../components/StatusBadge";

export type EligibilityStatus =
  | "eligible"
  | "potentially_eligible"
  | "info_needed";

const CONFIG: Record<
  EligibilityStatus,
  {
    label: string;
    tone: "green" | "gold" | "neutral";
    Icon: typeof CheckCircle2;
  }
> = {
  eligible: {
    label: "Eligible",
    tone: "green",
    Icon: CheckCircle2,
  },
  potentially_eligible: {
    label: "Potentially Eligible",
    tone: "gold",
    Icon: HelpCircle,
  },
  info_needed: {
    label: "More Info Needed",
    tone: "neutral",
    Icon: AlertCircle,
  },
};

export default function EligibilityBadge({
  status,
}: {
  status: EligibilityStatus;
}) {
  const config = CONFIG[status];

  return (
    <StatusBadge label={config.label} tone={config.tone} icon={config.Icon} />
  );
}
